import Component, { mixins } from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import WithRender from './InscriptionLieuExamenPage.html'

import {
  MAccordionGroup,
  MAccordion,
  MButton,
  MButtonSkin,
  MIcon,
  MMessage,
  MMessageSkin,
  MMessageState,
  MPanel,
  MSpinner
} from '@ulaval/modul-components'

import SessionSelect from '../global/session/SessionSelect'

import InscriptionLieuExamenService from './InscriptionLieuExamen.service'

import ROUTES from '@/router/ROUTES'
import { STORE_ACTIONS, STORE_GETTERS } from '@/store'

import IDossierEtudiant, { StatutInscription } from './IDossierEtudiant.model'
import IInscriptionLieuExamenInformations from './IInscriptionLieuExamenInformations.model'

@WithRender
@Component({
  components: {
    MAccordion,
    MAccordionGroup,
    MButton,
    MIcon,
    MMessage,
    MPanel,
    MSpinner,
    SessionSelect
  }
})
export default class InscriptionLieuExamenPage extends mixins(InscriptionLieuExamenService) {
  private isDossierEtudiantLoadingStateActive: boolean = false

  private readonly MMessageState: object = MMessageState
  private readonly MMessageSkin: object = MMessageSkin
  private readonly MButtonSkin: object = MButtonSkin

  private get messageImportantGlobal(): string | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_MESSAGE_IMPORTANT]
  }

  private get dossierEtudiant(): IDossierEtudiant | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_DOSSIER_ETUDIANT]
  }

  private get inscriptionLieuExamenInformations(): IInscriptionLieuExamenInformations | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_INFORMATIONS]
  }

  @Watch('$route.params.token', { immediate: true })
  private onRouteParameterTokenChange(token: string | undefined): void {
    if (token) {
      this.loadDossierEtudiant(token)
    }

    this.$store.dispatch(STORE_ACTIONS.INSCRIPTION_LIEU_EXAMEN_STORE_UPDATE_TOKEN, token)
  }

  private loadDossierEtudiant(token: string): void {
    this.isDossierEtudiantLoadingStateActive = true

    this.service_inscriptionLieuExamenService_fetchDossierEtudiant(token)
      .then((response: IDossierEtudiant) => {
        switch (response.statutInscription) {
          case StatutInscription.INSCRIPTION_EN_ATTENTE:
            this.mixin_router_navigate({
              name: ROUTES.INSCRIPTION_ETUDIANT_APERCU,
              params: this.$route.params,
              query: this.$route.query
            })
            break;
          case StatutInscription.INSCRIPTION_COMPLETEE:
          case StatutInscription.INSCRIPTION_TERMINEE:
            this.mixin_router_navigate({
              name: ROUTES.INSCRIPTION_ETUDIANT_FORMULAIRE,
              params: this.$route.params,
              query: this.$route.query
            })
            break;
          default:
            throw new Error('Error in function InscriptionLieuExamenPage.loadDossierEtudiant. Invalid StatutInscription.')
        }
      }).finally(() => {
        this.isDossierEtudiantLoadingStateActive = false
      })
  }

  private onRedirectToMonPortailButtonClick(): void {
    if (this.inscriptionLieuExamenInformations) {
      window.location.href = this.inscriptionLieuExamenInformations.monPortail.baseUrl
    }
  }

  private onDisplayGestionFicheRepondantButtonClick(): void {
    this.mixin_router_navigate({
      name: ROUTES.FICHE_REPONDANT_OVERVIEW,
      query: this.$route.query
    })
  }
}
